import { FC, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { SUBMODULE_TYPE } from '@constants/constants';

import { ShareDashboardComponentProps } from './types';

// Lazy import share components
const InvestorReportShare = lazy(() => import('./InvestorReport'));

const shareComponents: Partial<Record<SUBMODULE_TYPE, FC<ShareDashboardComponentProps>>> = {
  [SUBMODULE_TYPE.INVESTOR_REPORT_V2_EXT]: InvestorReportShare,
};

const Share: FC<{ type: SUBMODULE_TYPE }> = ({ type }) => {
  const { inviteId } = useParams<{ inviteId: string }>();

  const Component = shareComponents[type] ?? null;

  if (!inviteId) {
    return null;
  }

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
      }}
    >
      {Component ? <Component inviteId={inviteId} /> : <></>}
    </Box>
  );
};

export default Share;
